import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { interceptor } from "../utils/interceptor";
import { QUERY_OPTIONS } from "../lib/query-constants";

export const useGenericQuery = ({
    queryKey,
    endpoint,
    queryParams = {},
    onSuccess,
    onError,
    options = {},
    enabled = true
}) => {
    const axiosInstance = interceptor();
    return useQuery({
        queryKey,
        queryFn: async () => {
            const { data } = await axiosInstance.get(endpoint, { params: queryParams });
            return data.data;
        },
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
            else console.log(`Query ${queryKey} success:`, data);
        },
        onError: (error) => {
            if (onError) {
                onError(error);
                return; // ✅ Prevent React from showing overlay
            }
            if (Array.isArray(error.response?.data?.errors)) {
                error.response.data.errors.forEach(error => {
                    message.error(error.message);
                });
                return
            }
            if (error.response?.data?.message) {
                message.error(error.response.data.message);
                return
            }
            if (error.response?.data?.data?.error) {
                message.error(error.response.data.data.error);
                return
            }
            message.error("Something went wrong");
        },
        enabled,
        ...options,
        ...QUERY_OPTIONS,
    });
};
